import spSmartSuggestions from '../../views/smartsuggestion/smartsuggestions';
import { triggerEvent } from '../../vendor/googletagmanager/events';

const smartSuggestions = {
    _remove: function(productClassId) {
        var $product = $('#product-grid')
            .find('[data-productClassId="' + productClassId + '"]')
            .closest('.product-recommendations-container');

        if ($product.length) {
            $product
                .removeClass('product-recommendations-container')
                .find('.product-badge')
                .remove()
                .end()
                .find('.product-recommendation-message')
                .remove();
        }
    },
    _addEventListeners: function() {
        $('#product-grid').on(
            'click',
            '.smart-suggestions-modal-trigger',
            function(e) {
                e.preventDefault();

                if (
                    e.currentTarget.dataset.eventCategory &&
                    e.currentTarget.dataset.eventAction &&
                    e.currentTarget.dataset.eventLabel
                ) {
                    triggerEvent(
                        e.currentTarget.dataset.eventCategory,
                        e.currentTarget.dataset.eventAction,
                        e.currentTarget.dataset.eventLabel
                    );
                }

                smartPak.ui.modal($(e.currentTarget.getAttribute('href'))[0], {
                    title: e.currentTarget.title,
                    modalClass: 'product-recommendation-modal',
                    width: 550,
                    open: spSmartSuggestions.handleModalOpen(this._remove)
                });
            }.bind(this)
        );
    },
    _addRecommendations: function(recommendations) {
        recommendations.forEach(
            function(recommendation) {
                var $element = $('#product-grid').find(
                    '[data-productid="' + recommendation.suggestedProductClassId + '"]'
                );

                if ($element.length) {
                    this._addRecommendation(recommendation, $element.closest('.product'));
                }
            }.bind(this)
        );
    },
    _addRecommendation: function(recommendation, $element) {
        var PRODUCT_RECOMMENDATION_CONTAINER = 'product-recommendations-container',
            selector = spSmartSuggestions.buildSelector(recommendation);

        if ($element.hasClass(PRODUCT_RECOMMENDATION_CONTAINER)) {
            return;
        }

        triggerEvent(recommendation.eventCategory, 'View', recommendation.ruleName);

        $element
            .addClass(PRODUCT_RECOMMENDATION_CONTAINER)
            .prepend('<div class="product-badge product-recommendations-badge">SmartSuggestion</div>')
            .append(spSmartSuggestions.buildModal(recommendation, selector, this._findProductDetails($element)))
            .find('.category-review')
            .append(spSmartSuggestions.buildMessage(recommendation));
    },
    _findProductDetails: function($element) {
        var $link = $element.find('.product-name > a');
        return {
            price: $element
                .find('.product-price')
                .text()
                .trim(),
            url: $link.attr('href'),
            name: $link.text().trim(),
            src: $element
                .find('a img')
                .attr('src')
                .replace('224', '100')
        };
    },
    init: function(data, ids) {
        var recommendations = spSmartSuggestions.format(data.accountSuggestions, ids);

        recommendations.forEach(function(recommendation) {
            recommendation.eventCategory = 'SmartSuggestions-Desktop-SearchProd';
        });

        this._addRecommendations(recommendations);
        this._addEventListeners();
    }
};

export default smartSuggestions;
